// Import custom CSS
import '../sass/app.scss'
// Import Bootstrap's JS
import './bootstrap';

/** Disable submit button after submit. Avoid multiple submits. */
window.submitClicked = function () {
  for (const el of document.getElementById('initiative-application-form').querySelectorAll("[required]")) {
    if (!el.reportValidity()) {
      return;
    }
  }
  var btn = document.getElementById('submit-button');
  btn.disabled = true;
  document.getElementById('initiative-application-form').submit();
}
